import http from '../http'

export const getWxSignature = params =>
  http({
    url: '/signature',
    params
  })

export const getWxAuthLink = params =>
  http({
    url: '/user/redirectInfo',
    params
  })
